module.exports = "/_next/static/images/macpunks-story-3-af61507a5b6eb7578681286e3755425e.png";